














/* Created- 22 - Mar - 2019 */

import { Component, Vue, Prop } from "vue-property-decorator";
import { ParticaConfirmConfig } from "../../../Models/Components.model";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import { ParticaEvent } from "../../../Models/ParticaEvent";

@Component(
	{
		name: "ParticaConfirmDialog",
		components: { ParticaCard }
	})
export default class ParticaConfirmDialog extends Vue {
	@Prop() private config: ParticaConfirmConfig;
	private confirmed() {
		this.$emit("confirmed", { action: this.config.action, item: this.config.item } as ParticaEvent);
	}
	private cancelled() {
		this.$emit("cancelled");
	}
}

